import {useParams} from "react-router-dom";
import CreateCampaign from "./CreateCampaign";
import ScrollToTop from "../../components/common/ScrollToTop";
import {
  BoardContainer,
  TitleContainer
} from "../../assets/GlobalStyles";
import {ManageCreative} from "./ManageCreative";
import {CampaignFour} from "./steps/CampaignFour";
import {
  FormProvider,
  useForm
} from "react-hook-form";
import {BannerCreative} from "./BannerCreative";
import {AudioCreative} from "./AudioCreative";
import styled from "styled-components";
import CampaignStepNavigator from "./CampaignStepNavigator";

export default function Campaign() {
  const params = useParams();
  const methods = useForm();

  const isCreateCampaign =
      params.id === "campaign";

  return (
      <main>
        <ScrollToTop />

        <BoardContainer>
          <TitleContainer>
            <h1>광고 관리</h1>
            <TitleRightArea>
              {isCreateCampaign && (
                  <CampaignStepNavigator />
              )}

            </TitleRightArea>
          </TitleContainer>


          {isCreateCampaign && (
              <CreateCampaign />
          )}

          {params.id ===
              "manageCreative" && (
                  <ManageCreative />
              )}

          {params.id ===
              "manageCreativeDetail" && (
                  <FormProvider {...methods}>
                    <CampaignFour />
                  </FormProvider>
              )}

          {params.id ===
              "bannerCreative" && (
                  <BannerCreative />
              )}

          {params.id ===
              "audioCreative" && (
                  <AudioCreative />
              )}
        </BoardContainer>
      </main>
  );
}

const TitleRightArea = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 18px;
  margin-left: auto;
`;
